import _ from 'lodash';
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { ResourceContent } from '.';
import { useSelector } from 'react-redux';
import { AppRootState, AuthState } from '../redux';
import { AnyType } from '../interfaces';
import { ROUTE_PATHS, getConfigurationDataKey, clientApplicationNameSelector } from '../utils';

export const Footer = () => {
  const auth: AuthState = useSelector((state: AppRootState) => state.auth);
  const footerLinks = useSelector(
    (state: AppRootState) =>
      (((state.app.entities?.menus as AnyType) ?? {})[getConfigurationDataKey('privacyterms.footer')] as AnyType)?.data
        ?.links
  );
  const applicationName = useSelector(clientApplicationNameSelector);
  const isAuthenticated = auth.session?.user;
  const currentPath = window.location.pathname;
  return (
    <>
      {/* Cookie Notice */}
      <Container fluid className='cmx__cookie-notice p-0' data-testid='cmx__cookie-notice'>
        <Row className='align-items-start mx-0' style={{ paddingTop: '8px', paddingBottom: '0px' }}>
          <Col className='text-left px-3'>
            <h5 className='cookie-notice__title mb-1'>Use of Cookies</h5>
            <p className='cookie-notice__text mb-1'>This website uses cookies and similar technologies to:</p>
            <ul className='cookie-notice__list mb-1'>
              <li>Provide core site functionality and maintenance</li>
              <li>Analyze de-identified traffic and usage patterns to improve user experience</li>
            </ul>
            <p className='cookie-notice__text mb-1'>
              There is no option to disable non-essential cookies individually or as a group. By continuing, you agree
              to the use of these cookies as described above. If you do not agree to the use of cookies, please leave
              the website.
            </p>
            <p className='cookie-notice__text mb-0'>
              Additional details on how cookies are used by this website are available in the linked{' '}
              <a href='/privacy' className='cookie-notice__link' target='_blank' rel='noopener noreferrer'>
                Privacy Policy
              </a>
              .
            </p>
          </Col>
        </Row>
      </Container>

      {/* Main Footer */}
      <Container fluid className={isAuthenticated ? 'cmx_auth_footer' : 'cmx_footer'} data-testid='cmx__footer'>
        {isAuthenticated ? (
          footerLinks?.length > 0 &&
          (applicationName === 'PathwaysHCP1.5' || applicationName === 'JanssencarepathProviderPortal') &&
          currentPath === '/enrollmentModule' ? (
            <Row className='justify-content-center justify-content-lg-between align-items-center w-100'>
              {footerLinks?.map((link: AnyType, index: number) => (
                <Col lg='2' className='text-center text-lg-left' key={index}>
                  <a
                    key={_.kebabCase(link.label)}
                    href={(ROUTE_PATHS as AnyType)[link.url] || link.url}
                    target='_blank'
                    rel='noreferrer'
                    style={{ color: 'white', fontFamily: 'Arial', fontSize: '14px' }}>
                    {link.label}
                  </a>
                </Col>
              ))}

              <Col md='4' lg='4' className='text-center text-lg-right footer__text'>
                &copy;{new Date().getFullYear()} <ResourceContent contentKey='footer.copyright' />
              </Col>
              <Col lg='2' className='text-center text-lg-right'>
                <img className='cmx__footer__logo' src='/images/powered_by_logo_CareMetx_new.png' />
              </Col>
            </Row>
          ) : (
            <Row className='justify-content-center justify-content-lg-between align-items-center w-100'>
              <Col md='12' lg='4' className='text-center text-lg-right footer__text'>
                &copy;{new Date().getFullYear()} <ResourceContent contentKey='footer.copyright' />
              </Col>
              <Col lg='4' className='text-center text-lg-right'>
                <img className='cmx__footer__logo' src='/images/powered_by_logo_CareMetx_new.png' />
              </Col>
            </Row>
          )
        ) : (
          <Row className='justify-content-center justify-content-lg-between align-items-center w-100'>
            <Col md='6' lg='4' className='text-center text-md-left footer__text'>
              &copy;{new Date().getFullYear()} <ResourceContent contentKey='footer.copyright' />
            </Col>
            <Col md='6' lg='4' className='text-center text-md-right text-lg-center' />
            <Col lg='4' className='text-center text-lg-right'>
              <img className='cmx__footer__logo' src='/images/powered_by_logo_CareMetx_new.png' />
            </Col>
          </Row>
        )}
      </Container>
    </>
  );
};
